'use client';

import type { ClassValue } from 'clsx';

import { Dialog } from '@vs-shop/ui/dialog';
import { clsxm } from '@vs-shop/utils';
import { useState } from 'react';

import ProductPriceHistoryInteractive from './ProductPriceHistoryInteractive';
import ProductPriceHistoryTrigger from './ProductPriceHistoryTrigger';

type Props = {
  productCode: string;
  productName: string;
  className?: ClassValue;
};

export default function ProductPriceHistory({ productCode, productName, className }: Props) {
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  if (hasBeenOpened) {
    return (
      <ProductPriceHistoryInteractive
        productCode={productCode}
        productName={productName}
        className={className}
      />
    );
  }

  return (
    <Dialog
      onOpenChange={(open) => {
        if (open) {
          setHasBeenOpened(true);
        }
      }}
    >
      <ProductPriceHistoryTrigger className={clsxm(className)} />
    </Dialog>
  );
}
